import React, { useState } from "react";
import ColorPopup from "../../Shared/ColorPopup";
import Tabs from "../../../Tabs";
import TextView from "../../../TextView";
import { colors } from "../../../../utils";
import MarginBox from "../../Shared/MarginBox";

export default function Layout({
  handleChange,
  backgroundColor,
  waveColor,
  iconColor,
  textColor,
  margin,
  handleMarginChange,
  handleSliderMarginChange,
  allSideMargin,
  handleMarginCheckBox,
  isApplyMarginOnAllSides,
}) {
  const categories = ["Background", "Text", "Waveforms", "Icon"];
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);

  const handleCategoryChange = (event, newValue) => {
    event.stopPropagation();
    setSelectedCategory(newValue);
  };

  const handleAdjustment = (type, side, operation) => {
    if (type === "margin") {
      const newValue =
        operation === "increase" ? margin[side] + 1 : margin[side] - 1;
      if (newValue >= 0) handleMarginChange(side, newValue);
    }
  };

  return (
    <div>
      <div style={{ marginBottom: 10 }}>
        <TextView variant="subtitle">Play Bar Customization</TextView>
      </div>
      <div
        style={{
          padding: "5px 10px",
          background: colors.background,
          borderRadius: 5,
          marginTop: 10,
        }}
      >
        <TextView>
          <b>Note:</b> Layout options do not apply to 'Embed Code' play bars
        </TextView>
      </div>
      <Tabs
        categories={categories}
        selectedCategory={selectedCategory}
        onCategoryChange={handleCategoryChange}
      />
      {selectedCategory === "Background" && (
        <ColorPopup
          title="Background Color"
          background={backgroundColor}
          handleChangeBackgroundColor={(val) =>
            handleChange("backgroundColor", val)
          }
          resetBackgroundColor={() => handleChange("resetBackgroundColor")}
          isHideGradient={false}
          showSuggestedColorPalette={true}
          showSlider={false}
          showAccordion={false}
        />
      )}

      {selectedCategory === "Waveforms" && (
        <ColorPopup
          title="Wave Color"
          background={waveColor}
          handleChangeBackgroundColor={(val) => handleChange("waveColor", val)}
          resetBackgroundColor={() => handleChange("resetWaveColor")}
          isHideGradient={true}
          showSuggestedColorPalette={true}
          showSlider={false}
          showAccordion={false}
        />
      )}

      {selectedCategory === "Icon" && (
        <ColorPopup
          title="Icon Color"
          background={iconColor}
          handleChangeBackgroundColor={(val) => handleChange("iconColor", val)}
          resetBackgroundColor={() => handleChange("resetIconColor")}
          isHideGradient={true}
          showSuggestedColorPalette={true}
          showSlider={false}
          showAccordion={false}
        />
      )}

      {selectedCategory === "Text" && (
        <ColorPopup
          title="Text Color"
          allowTransparent={false}
          background={textColor}
          handleChangeBackgroundColor={(val) => handleChange("textColor", val)}
          resetBackgroundColor={() => handleChange("resetTextColor")}
          isHideGradient={true}
          showSuggestedColorPalette={true}
          showSlider={false}
          showAccordion={false}
        />
      )}

      <MarginBox
        margin={margin}
        increaseMargin={(side) => handleAdjustment("margin", side, "increase")}
        decreaseMargin={(side) => handleAdjustment("margin", side, "decrease")}
        isApplyMarginOnAllSides={isApplyMarginOnAllSides}
        handleMarginCheckBox={handleMarginCheckBox}
        allSideMargin={allSideMargin}
        handleSliderMarginChange={handleSliderMarginChange}
        handleMarginChange={handleMarginChange}
        hideSlider
      />
    </div>
  );
}
